<template>
  <div class="TranProgramModule-view-page w-100">
    <basic-subheader>
      <template v-slot:actions>
        <div class="header-buttons-container w-100">
          <b-row class="d-flex justify-content-between w-100">
            <b-col cols="6">
              <div class="coach__info d-flex">
                <div class="d-flex mr-3 align-items-center">
                  <avatar
                    size="40px"
                    :text="customerInfo.fullName"
                    :rounded="true"
                    :src="customerInfo.imageUrl.url"
                  />
                  <div class="d-flex mr-3 flex-column ml-3">
                    <p class="mb-0 font-weight-bolder">
                      {{ customerInfo.fullName }}
                    </p>
                    <p class="mb-0 text-gray">
                      Gói
                      {{
                        customerInfo.tranServicePackageName != null
                          ? customerInfo.tranServicePackageName
                          : 'Free'
                      }}
                    </p>
                  </div>
                </div>
                <div class="d-flex mr-3 flex-column">
                  <p class="mb-0 text-gray">User code</p>
                  <p class="mb-0 font-weight-bolder">{{ customerInfo.code }}</p>
                </div>
                <div class="d-flex mr-3 flex-column">
                  <p class="mb-0 text-gray">Năm sinh</p>
                  <!-- <p class="mb-0 font-weight-bolder">
                  {{
                    customerInfo.dateOfBirth > 0
                      ? convertTimestampToDate(customerInfo.dateOfBirth, 'YYYY')
                      : null
                  }}
                </p> -->
                  <p class="mb-0 font-weight-bolder">
                    {{
                      convertTimestampToDate(customerInfo.dateOfBirth, 'YYYY')
                    }}
                  </p>
                </div>
                <div class="d-flex mr-3 flex-column">
                  <p class="mb-0 text-gray">Giới tính</p>
                  <p class="mb-0 font-weight-bolder">
                    {{ customerInfo.gender }}
                  </p>
                </div>

                <div class="d-flex mr-3 flex-column">
                  <p class="mb-0 text-gray">Tình trạng</p>
                  <p class="mb-0 font-weight-bolder">
                    {{ customerInfo.diabetes.name }}
                  </p>
                </div>
                <div class="d-flex mr-3 flex-column">
                  <p class="mb-0 text-gray">Thời gian có bệnh</p>
                  <p class="mb-0 font-weight-bolder">
                    {{ getDiabeteYears() }}
                  </p>
                </div>
              </div>
            </b-col>
            <b-col cols="6 d-flex justify-content-end">
              <b-dropdown
                id="dropdown-right dropdown-form"
                class="dropdown-form-filter mr-3"
                no-caret
                right
              >
                <template #button-content>
                  <span class="svg-icon">
                    <inline-svg
                      src="/media/svg/icons/Neolex/Basic/filter.svg"
                    />
                  </span>
                  Bộ lọc
                </template>
                <h6 class="d-flex align-items-center mb-0 p-4">
                  <span class="svg-icon mr-3">
                    <inline-svg
                      src="/media/svg/icons/Neolex/Basic/filter.svg"
                    />
                  </span>
                  Bộ lọc hoạt động
                </h6>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-form>
                  <b-container class="p-0">
                    <b-row>
                      <b-col cols="4">
                        <basic-select
                          label="Loại hoạt động"
                          placeholder="Chọn loại hoạt động"
                          name="activityType"
                          :options="activityTypes"
                          :value.sync="filter.activityTypeId"
                          track-by="value"
                          value-label="name"
                        ></basic-select>
                      </b-col>
                      <b-col cols="4">
                        <basic-select
                          label="ServicePackage"
                          placeholder="Chọn ServicePackage"
                          name="servicePackage"
                          :options="servicePackages"
                          :value.sync="filter.servicePackage"
                          track-by="Id"
                          value-label="Name"
                        ></basic-select>
                      </b-col>
                      <b-col cols="4">
                        <basic-select
                          label="Program"
                          placeholder="Chọn program"
                          name="program"
                          :options="programs"
                          :value.sync="filter.programId"
                          track-by="Id"
                          value-label="Name"
                        ></basic-select>
                      </b-col>
                      <b-col cols="4">
                        <basic-select
                          label="Module"
                          placeholder="Chọn module"
                          name="module"
                          :options="modules"
                          :value.sync="filter.moduleId"
                          track-by="Id"
                          value-label="Name"
                        ></basic-select>
                      </b-col>
                      <b-col cols="4">
                        <basic-date-picker
                          :value.sync="filter.startDate"
                          label="Ngày bắt đầu"
                          placeholder="Ngày bắt đầu"
                          name="dateRange"
                          format="YYYY-MM-DD"
                        />
                      </b-col>
                      <b-col cols="4">
                        <basic-date-picker
                          :value.sync="filter.endDate"
                          label="Ngày kết thúc"
                          placeholder="Ngày kết thúc"
                          name="dateRange"
                          format="YYYY-MM-DD"
                        />
                      </b-col>
                    </b-row>
                  </b-container>
                </b-dropdown-form>
                <b-dropdown-divider></b-dropdown-divider>
                <div
                  class="d-flex align-items-center justify-content-lg-end m-0 p-4"
                >
                  <b-button
                    class="btn ml-2"
                    tabindex="0"
                    @click.prevent="resetFilter"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                      />
                    </span>
                    Reset bộ lọc
                  </b-button>
                  <b-button
                    class="btn ml-2"
                    href="#"
                    tabindex="0"
                    @click="searchRequest"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/filter.svg"
                      />
                    </span>
                    Lọc dữ liệu
                  </b-button>
                </div>
              </b-dropdown>
              <b-button
                class="btn mr-3"
                href="#"
                tabindex="0"
                @click="resetRequest"
              >
                <span class="svg-icon">
                  <inline-svg
                    src="/media/svg/icons/Neolex/Basic/refresh-cw.svg"
                  />
                </span>
                Làm mới dữ liệu
              </b-button>
              <b-button
                class="btn btn-success mr-3"
                type="button"
                @click="showActionModal"
              >
                <span class="svg-icon">
                  <inline-svg
                    src="/media/svg/icons/Neolex/Basic/settings.svg"
                  />
                </span>
                Chức năng
              </b-button>

              <b-button
                class="btn btn-success mr-3"
                type="button"
                @click="showAddModuleModal"
              >
                <span class="svg-icon">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/plus.svg" />
                </span>
                Thêm hoạt động
              </b-button>

              <div class="navigation-buttons">
                <b-button class="btn" type="button" @click="returnPage">
                  <span class="svg-icon">
                    <inline-svg
                      src="/media/svg/icons/Neolex/Arrows/arrow-left.svg"
                    />
                  </span>
                  Trở về trước
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
    </basic-subheader>

    <ScheduleTranUserPackageDay
      ref="ScheduleServicePackageDay"
      @delete-activity="deleteActivity"
      @reset-request="resetRequest"
      :moduleData="moduleData"
      :moduleId="$route.params.id"
      :numberOfWeeks="numberOfWeeks"
      @edit-activity="editActivity"
    />
    <UserPackageActionModal
      ref="userPackageActionModal"
      :setupData="setupData"
      :selectedItem="selectedItems"
      @loadData="loadTranUserPackageActivity"
      @close-modal="handleCloseModal"
      @reset-request="resetRequest"
    />
    <ModalCreateDetail
      ref="modalCreate"
      :key="selectedItems?.timestamp || 'default'"
      :setupData="setupData"
      @loadData="loadData"
      :selectedItem="selectedItems"
    ></ModalCreateDetail>
    <b-modal
      id="module-modal"
      ref="moduleModal"
      :title="'Thêm hoạt động mới'"
      size="lg"
      hide-footer
      @hidden="resetModuleForm"
    >
      <div class="form-container">
        <div class="form-row d-flex">
          <basic-select
            label="Loại hoạt động"
            placeholder="Chọn loại hoạt động"
            :options="activityTypes"
            track-by="value"
            value-label="name"
            v-model="activityTypeForm.activityTypeId"
            @input="onActivityTypeChange"
          >
          </basic-select>
          <basic-select
            label="Hoạt động"
            placeholder="Chọn hoạt động"
            :options="filteredActivities"
            track-by="value"
            value-label="displayName"
            v-model="activityForm.activityId"
          ></basic-select>
        </div>
        <basic-date-picker
          v-model="activityForm.date"
          label="Ngày thêm hoạt động"
          placeholder="Ngày thêm hoạt động"
          name="startDate"
          data-vv-As="Ngày thêm hoạt động"
          format="YYYY-MM-DD"
        />
        <div class="modal-actions mt-4">
          <b-button
            variant="success"
            @click="handleSubmitActivity"
            class="mr-2"
          >
            {{ 'Thêm hoạt động' }}
          </b-button>
          <b-button variant="secondary" @click="hideModal"> Hủy </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ScheduleTranUserPackageDay from './components/ScheduleTranUserPackageDay.vue';
import moment from 'moment';

export default {
  components: {
    ScheduleTranUserPackageDay,
    ModalCreateDetail: () =>
      import('./components/modal/ModalCreateActivity.vue'),
    UserPackageActionModal: () =>
      import('./components/modal/UserPackageActionModal.vue'),
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      days: [
        'Ngày 1',
        'Ngày 2',
        'Ngày 3',
        'Ngày 4',
        'Ngày 5',
        'Ngày 6',
        'Ngày 7',
      ],
      loading: false,
      isFirstLoad: false,
      moduleData: {},
      actualDays: [],
      viewMode: 'week',
      activityForm: {
        activityId: '',
        startWeek: 1,
        color: '#16A45A',
        date: null,
      },
      activityTypeForm: {
        activityTypeId: '',
      },
      activityType: null,
      activityTypes: [],
      activities: [],
      isEditing: false,
      editingId: null,
      numberOfWeeks: 0,
      selectedDay: 0,
      defaultColor: '#16A45A',
      selectedItems: null,
      customerInfo: null,
      showFilter: false,
      filter: {
        accountId: null,
        activityTypeId: null,
        servicePackage: null,
        programId: null,
        moduleId: null,
        startDate: null,
        endDate: null,
      },
    };
  },
  computed: {

    filteredActivities() {
      if (!this.activityTypeForm.activityTypeId) {
        return this.activities.map((activity) => ({
          ...activity,
          displayName: activity.code
            ? `(${activity.code}) ${activity.name}`
            : activity.name,
        }));
      }
      const selectedActivityTypeId =
        typeof this.activityTypeForm.activityTypeId === 'object'
          ? this.activityTypeForm.activityTypeId.value
          : this.activityTypeForm.activityTypeId;

      return this.activities
        .filter((activity) => activity.activityType === selectedActivityTypeId)
        .map((activity) => ({
          ...activity,
          displayName: activity.code
            ? `(${activity.code}) ${activity.name}`
            : activity.name,
        }));
    },


    activeScheduleComponent() {
      return this.$refs.ScheduleProgramModuleDay;
    },
    startAtDay() {
      return (this.activityForm.startWeek - 1) * 7 + this.selectedDay + 1;
    },
  },
  methods: {
    searchRequest() {
      this.loadTranUserPackageActivity();
      document.body.click();
    },
    removeEmpty(obj) {
      const newObj = {};
      for (let key in obj) {
        if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
          newObj[key] = obj[key];
        }
      }
      return newObj;
    },
    resetFilter() {
      this.filter = {
        accountId: this.$route.params.id,
        activityTypeId: null,
        servicePackage: null,
        programId: null,
        moduleId: null,
        startDate: null,
        endDate: null,
      };
      this.resetRequest();
      document.body.click();
    },
    searchParams() {
      return this.removeEmpty({
        accountId: this.filter.accountId,
        activityTypeId: this.filter.activityTypeId,
        tranServicePackageId: this.filter.servicePackage,
        tranProgramId: this.filter.programId,
        tranProgramModuleId: this.filter.moduleId,
        tranStartDate: this.convertDateToTimestamp(this.filter.startDate),
        tranEndDate: this.convertDateToTimestamp(this.filter.endDate),
      });
    },
    convertDateToTimestamp(date) {
      if (!date) return null;
      return Math.floor(new Date(date).getTime() / 1000);
    },
    toggleFilter() {
      this.showFilter = !this.showFilter;
    },

    applyFilter() {
      this.loadTranUserPackageActivity();
      this.showFilter = false;
    },

    onActivityTypeChange() {
      this.activityForm.activityId = '';
    },
    returnPage() {
      this.$router.push({
        name: 'tran_user_package_list',
      });
    },
    showAddModuleModal() {
      this.resetModuleForm();
      this.$refs.moduleModal.show();
    },
    async showActionModal(activity = null) {
      if (activity) {
        this.selectedItems = {
          userPackages: this.userPackages,
        };
      } else {
        this.selectedItems = null;
      }
      this.$nextTick();
      this.$refs.userPackageActionModal.openModal();
    },
    handleLoading(state) {
      this.loading = state;
    },
    hideModal() {
      this.$refs.moduleModal.hide();
    },
    resetModuleForm() {
      this.activityForm = {
        activityId: '',
        activityTypeId: '',
        startWeek: 1,
        color: this.defaultColor,
      };
      this.activityTypeForm = {
        activityTypeId: '',
      };
      this.selectedDay = 0;
      this.isEditing = false;
      this.editingId = null;
    },
    updateStartAtDay() {
      this.activityForm.startAtDay = this.startAtDay;
    },
    async handleSubmitActivity() {
      if (!this.activityForm.activityId) {
        this.$swal('Lỗi!', 'Vui lòng chọn hoạt động', 'error');
        return;
      }
      if (!this.activityForm.date) {
        this.$swal('Lỗi!', 'Vui lòng chọn thời gian', 'error');
        return;
      }
      const day = moment();
      if (this.activityForm.date < day.format('YYYY-MM-DD')) {
        this.$swal('Lỗi!', 'Thời gian phải lớn hơn ngày hiện tại', 'error');
        return;
      }
      let confirm = await this.$swal({
        text: `${'Bạn có chắc muốn tạo hoạt động này không?'}`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-success',
            closeModal: true,
          },
        },
      });
      if (confirm) {
        try {
          this.loading = true;
          const tranprogramActivityId =
            typeof this.activityForm.activityId === 'object'
              ? this.activityForm.activityId.value
              : this.activityForm.activityId;
          const date = new Date(`${this.activityForm.date}T00:00:00Z`);
          const epochTimestampInSeconds = Math.floor(date.getTime() / 1000);
          const payload = {
            programActivityId: tranprogramActivityId,
            TimeReminder: epochTimestampInSeconds,
            AccountId: this.moduleData.activities[0].accountId,
          };
          await this.$api.post('TranUserPackage', payload);
          this.$swal('Thành công!', 'Đã thêm hoạt động thành công', 'success');

          this.hideModal();
        } catch (error) {
          console.error('Error saving activity:', error);
          this.$swal('Lỗi!', 'Đã có lỗi xảy ra', 'error');
        } finally {
          this.loading = false;
          this.loadTranUserPackageActivity();
        }
      }
    },

    async resetRequest() {
      try {
        this.loading = true;
        await Promise.all([this.loadActivityType(), this.loadActivities()]);
        if (this.$route.params.id) {
          await this.loadTranUserPackageActivity();
        }
        this.$swal('Thành công!', 'Dữ liệu đã được làm mới', 'success');
      } catch (error) {
        console.error('Error resetting data:', error);
        this.$swal('Lỗi!', 'Không thể reset dữ liệu', 'error');
      } finally {
        this.loading = false;
      }
    },
    async editActivity(activity) {
      try {
        const { data } = await this.$api.get(
          `TranProgramActivity/tran-user-package-activity/${activity.id}`,
        );

        this.selectedItems = {
          action: 'view',
          item: { ...data },
          timestamp: Date.now(),
        };

        await this.$nextTick();

        if (this.$refs.modalCreate) {
          this.$refs.modalCreate.openModal();
        } else {
          console.error('Modal ref not found');
        }
      } catch (error) {
        console.error('Error loading activity:', error);
        this.$swal('Lỗi!', 'Không thể tải dữ liệu hoạt động', 'error');
      }
    },
    async deleteActivity(activityModuleMappingId) {
      try {
        this.loading = true;
        await this.$api.delete(`TranUserPackage/${activityModuleMappingId}`);
        this.$swal('Thành công!', 'Đã xóa hoạt động thành công', 'success');
      } catch (error) {
        this.$swal('Lỗi!', 'Đã có lỗi xảy ra khi xóa hoạt động', 'error');
      } finally {
        this.loading = false;
      }
    },

    async loadTranUserPackageActivity() {
      if (!this.$route.params.id) return;
      try {
        const accountId = this.$route.params.id;
        this.loading = true;
        const response = await this.$api.get(`TranUserPackage/accountId`, {
          params: {
            accountId: accountId,
            ...this.searchParams(),
          },
        });
        const data = response?.data;

        const items = Array.isArray(data?.items)
          ? data.items
          : Array.isArray(data)
          ? data
          : [];
        if (!items.length) {
          console.warn('Không có dữ liệu hoạt động từ API:', data);
          const today = moment().startOf('day');
          const startOfWeek = today.clone().startOf('isoWeek');
          const actualDays = Array.from({ length: 7 }, (_, index) =>
            startOfWeek.clone().add(index, 'days').format('DD/MM/YYYY'),
          );
          this.moduleData = { activities: [], totalWeek: 1, actualDays };
          this.numberOfWeeks = 1;
          this.$swal(
            'Cảnh báo!',
            'Không có dữ liệu hoạt động để hiển thị',
            'warning',
          );
          return;
        }

        const minStartDate = Math.min(
          ...items.map((activity) => activity.tranStartDate || moment().unix()),
        );
        const maxStartDate = Math.max(
          ...items.map((activity) => activity.tranStartDate || moment().unix()),
        );
        const totalDays =
          moment.unix(maxStartDate).diff(moment.unix(minStartDate), 'days') + 1;
        const totalWeek = Math.ceil(totalDays / 7) || 1;

        const adjustedTotalWeek = totalWeek + 1;

        const startOfWeek = moment.unix(minStartDate).startOf('isoWeek');
        const actualDays = Array.from(
          { length: adjustedTotalWeek * 7 },
          (_, index) =>
            startOfWeek.clone().add(index, 'days').format('DD/MM/YYYY'),
        );

        const activities = items.map((activity) => {
          const type = this.activityTypes.find(
            (t) => t.value === activity.activityTypeId,
          );
          return {
            id: activity.id,
            accountId: activity.accountId,
            name: activity.name || 'Không xác định',
            startAtDay: this.calculateStartAtDay(
              activity.tranStartDate,
              minStartDate,
            ),
            actualDate: moment
              .unix(activity.tranStartDate)
              .format('DD/MM/YYYY'),
            color: type?.color || this.defaultColor,
            activityModuleMappingId: activity.id,
            code: activity.code || null,
            userPackageId: activity.userPackageId,
            activityId: activity.tranProgramActivityId,
            status: activity.status || null,
            surveyId: activity.surveyId || null,
            questionSurveys: activity.questionSurveys || null,
            bloodSugarCount: activity.bloodSugarCount || null,
          };
        });

        this.moduleData = {
          activities,
          totalWeek: adjustedTotalWeek,
          actualDays,
        };
        this.numberOfWeeks = this.moduleData.totalWeek;

        if (this.$refs.ScheduleServicePackageDay) {
          this.$refs.ScheduleServicePackageDay.updateNumberOfWeeks(
            this.numberOfWeeks,
          );
        }
      } catch (error) {
        console.error('Error loading module data:', error);
        this.$swal('Lỗi!', 'Không thể tải dữ liệu hoạt động', 'error');
        const today = moment().startOf('day');
        const startOfWeek = today.clone().startOf('isoWeek');
        const actualDays = Array.from({ length: 7 }, (_, index) =>
          startOfWeek.clone().add(index, 'days').format('DD/MM/YYYY'),
        );
        this.moduleData = { activities: [], totalWeek: 1, actualDays };
        this.numberOfWeeks = 1;
      } finally {
        this.loading = false;
      }
    },

    getDiabeteYears() {
      return `${
        this.customerInfo.totalYears < 1 ||
        (this.customerInfo.totalYears === 1 &&
          this.customerInfo.totalMonths === 0)
          ? '< 1'
          : this.customerInfo.totalYears
      }`;
    },
    calculateStartAtDay(tranStartDate, minStartDate) {
      const startDate = moment.unix(tranStartDate || moment().unix());
      const baseDate = moment.unix(minStartDate);
      const startOfWeek = baseDate.clone().startOf('isoWeek');
      const diffDays = startDate.diff(startOfWeek, 'days') + 1;
      return diffDays >= 1 ? diffDays : 1;
    },
    async loadActivityType() {
      try {
        this.loading = true;
        const { data } = await this.$api.get(
          `/ProgramActivityLevel/setup-list`,
        );
        this.setupData = data;
        this.activityTypes = data.Types.map((item) => ({
          value: item.Id,
          name: item.Name,
          color: item.Color,
        }));
      } catch (error) {
        console.error('Error loading activityType:', error);
        this.$swal('Lỗi!', 'Không thể tải danh sách loại hoạt động', 'error');
        this.activityTypes = [];
      } finally {
        this.loading = false;
      }
    },
    async loadActivities() {
      try {
        this.loading = true;
        const { data } = await this.$api.get('/ProgramActivity/All');
        this.activities = data.map((item) => ({
          value: item.id || '',
          name: item.name || 'Không có tên',
          activityType: item.activityTypeId,
          code: item.code || null,
          color: item.color || null,
        }));
      } catch (error) {
        console.error('Error loading activities:', error);
        this.$swal('Lỗi!', 'Không thể tải danh sách hoạt động', 'error');
        this.activities = [];
      } finally {
        this.loading = false;
      }
    },
    async getSetupSearchMenu() {
      try {
        this.$store.commit('context/setLoading', true);
        const accountId = this.$route.params.id;
        const { data } = await this.$api.get(
          `TranUserPackage/setup-list?accountId=${accountId}`,
        );
        (this.userPackages = data.userPackages),
          (this.servicePackages = data.tranServicePackages),
          (this.programs = data.tranPrograms),
          (this.modules = data.programModules);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
    async getPatientData() {
      try {
        this.$store.commit('context/setLoading', true);
        const accountId = this.$route.params.id;
        const { data } = await this.$api.get(
          `Patient/accountId?id=${accountId}`,
        );
        this.customerInfo = data;
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi',
          msg: error,
        });
      } finally {
        this.$store.commit('context/setLoading', false);
      }
    },
  },
  watch: {
    '$route.params.id': {
      handler(newId) {
        if (newId) {
          this.loadTranUserPackageActivity();
        }
      },
      immediate: false,
    },
  },
  async mounted() {
    try {
      if (this.$route.params.id) {
        this.filter.accountId = this.$route.params.id;
      }

      // Load activityTypes first (needed for color mapping in activities)
      await this.loadActivityType();

      // Then load the rest in parallel
      await Promise.all([
        this.loadTranUserPackageActivity(),
        this.loadActivities(),
        this.getSetupSearchMenu(),
        this.getPatientData(),
      ]);
    } catch (error) {
      console.error('Error during mounted:', error);
    }
  },
};
</script>

<style lang="scss" scoped>
.font-weight-bold {
  font-weight: 600;
}

.header-buttons-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.navigation-buttons {
  display: flex;
  align-items: center;
}

.form-container {
  padding: 10px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.form-group {
  flex: 1;
  min-width: 300px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
}

::v-deep .subheader-content__actions {
  width: 100%;
  .header-buttons-container {
    width: 100%;
  }
}

.custom-btn {
  border: 1px solid #008479 !important;
  color: #008479 !important;
  background-color: transparent;
}

.toggle-text.active {
  font-weight: bold;
}

.filter-dropdown-container {
  position: relative;
  z-index: 1000;
}

.filter-card {
  background: white;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 800px;
}

.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 900px;
    }
  }
}

/* Responsive styling */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }

  .form-group {
    flex: 1;
  }
  .filter-card {
    margin-left: -15px;
    margin-right: -15px;
  }

  .header-buttons-container {
    flex-direction: column;
    align-items: stretch;
  }

  .btn {
    margin-bottom: 10px !important;
  }
  .dropdown-form-filter {
    .dropdown-menu {
      .container {
        width: 100%; // Full width trên mobile
        padding: 0 10px;
      }
    }
  }
}
</style>
